import clsx from 'clsx';
import type { ReactNode } from 'react';
import './ChoiceCard.css';

export interface ChoiceCardProps {
  /** Marks this card as the chosen option (primary border + wash). */
  selected?: boolean;
  onPress: () => void;
  /** Leading visual — emoji, glyph or badge; rendered as-is. */
  leading?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
}

/**
 * ChoiceCard — tappable selectable option card (leading visual + title +
 * description) for pickers like onboarding's level & daily-goal steps.
 * Single-select semantics live in the parent; the card only reports taps
 * and renders its `selected` flag.
 */
export function ChoiceCard({
  selected,
  onPress,
  leading,
  title,
  description,
  className,
}: ChoiceCardProps) {
  return (
    <button
      type="button"
      className={clsx('fluent-choice-card', className)}
      data-selected={selected || undefined}
      aria-pressed={selected === true}
      onClick={onPress}
    >
      {leading}
      <span className="fluent-choice-card__body">
        <span className="fluent-choice-card__title">{title}</span>
        {description !== undefined && (
          <span className="fluent-choice-card__desc">{description}</span>
        )}
      </span>
    </button>
  );
}
